import { getLocation, goBack } from 'connected-react-router';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { Redirect, Route, Switch } from 'react-router';
import '../../assets/general-flow/options.scss';
import '../../assets/general-flow/sidebar.scss';
import '../../assets/general-flow/smallStyling.scss';
import '../../assets/general-flow/widget.scss';
import { ProgressHeader, SheetLayout, SheetLayoutContentWrapper, StepIndicator } from '../../brenger-shared-ui';
import { useTypedSelector } from '../../hooks';
import { r } from '../../routes';
import { translate } from '../../utils/localization';
import { HelpModal } from './components/HelpModal';
import { ProductPayment } from './components/ProductPayment';
import { ProductSelection } from './components/ProductSelection';
import { SubStepAuctionTypes } from './components/SubStepAuctionTypes';
import { SubStepDate } from './components/SubStepDate';
import { SubStepDestination } from './components/SubStepDestination';
import { SubStepFloor } from './components/SubStepFloor';
import { SubStepHelpCombined } from './components/SubStepHelpCombined';
import { SubStepHomeSituation } from './components/SubStepHomeSituation';
import { SubStepInvoice } from './components/SubStepInvoice';
import { SubStepSituation } from './components/SubStepSituation';
import { SubStepTime } from './components/SubStepTime';
import { TimeModal } from './components/TimeModal';
import { BlockedTrModal } from './components/BlockedTrModal';
import { MarktplaatsWelcomeModal } from './components/MarktplaatsWelcomeModal';
import { ContactPage } from './components/contact';
import { SubStepTerms } from './components/terms';
import SidebarLayout from './containers/SidebarLayout';
import { useDispatch } from 'react-redux';
import { getQuote } from './ducks';
import { BlockedReasonsFlash } from './components/BlockedReasons';
import { useActiveDiscount } from './hooks/useActiveDiscount';

export const FLOW_TYPE = 'general';

export const GeneralFlow: React.FC = () => {
  const dispatch = useDispatch();
  useActiveDiscount();
  const { pathname } = useTypedSelector(getLocation);
  const progressStep = useTypedSelector(state => state.generalTransport.layout.step);
  const layout = useTypedSelector(state => state.generalTransport.layout);
  const blocked = useTypedSelector(getQuote)?.blocked;

  React.useEffect(() => {
    window.document.title = 'Brenger';
    // mark it for styling
    document.body.classList.add('transport-request-flow');
    // plus clean it up
    return document.body.classList.remove('transport-request-flow');
  }, []);

  const isTerms = progressStep > 6 && !pathname.includes('invoice');

  return (
    <>
      <ProgressHeader
        goBack={() => dispatch(goBack())}
        goBackText={String(translate('nav.previous'))}
        currentStep={progressStep}
        totalSteps={7}
      />
      <SheetLayout
        sheetOpen={layout.sheet}
        sidebar={<SidebarLayout />}
        loading={layout.step_loading}
        noSidebar={isTerms}
      >
        <SheetLayoutContentWrapper className={'sheet-layout--content-wrapper--top-header'}>
          <div className={'sheet-layout--container'}>
            <StepIndicator currentStep={layout.step}>
              {pathname.includes('invoice') ? (
                <Translate id={'request_flow.auction.lot_add_invoice'} />
              ) : (
                <Translate id={'request_flow.headers.step_' + layout.step} />
              )}
              {!isTerms && <HelpModal />}
            </StepIndicator>
            {blocked?.result && (
              <div className="pb-1 pt-1">
                <BlockedReasonsFlash withReasons={isTerms} />
              </div>
            )}
          </div>
        </SheetLayoutContentWrapper>
        <Switch>
          <Route path={r.generalFlow.destination.index()} exact={true} component={SubStepDestination} />
          <Route exact={true} path={r.generalFlow.pickup.index()} component={SubStepSituation} />
          <Route exact={true} path={r.generalFlow.pickup.auction()} component={SubStepAuctionTypes} />
          <Route path={r.generalFlow.homeSituation.index()} component={SubStepHomeSituation} />
          <Route path={r.generalFlow.items.index()} exact={false} component={ProductSelection} />
          <Route path={r.generalFlow.help.index()} component={SubStepHelpCombined} />
          <Route path={r.generalFlow.productPayment.index()} component={ProductPayment} />
          <Route exact={true} path={r.generalFlow.date.index()} component={SubStepDate} />
          <Route exact={true} path={r.generalFlow.date.delivery()} component={SubStepDate} />
          <Route path={r.generalFlow.pickup.floor()} component={SubStepFloor} />
          <Route path={r.generalFlow.delivery.floor()} component={SubStepFloor} />
          <Route exact={true} path={r.generalFlow.time.index()} component={SubStepTime} />
          <Route exact={true} path={r.generalFlow.time.delivery()} component={SubStepTime} />
          <Route path={r.generalFlow.contact.index()} exact={false} component={ContactPage} />
          <Route path={r.generalFlow.terms.index()} component={SubStepTerms} />
          <Route path={r.generalFlow.invoice.home()} component={SubStepInvoice} />
          <Redirect to={r.generalFlow.destination.index()} />
        </Switch>
        <TimeModal />
        <BlockedTrModal />
        <MarktplaatsWelcomeModal />
      </SheetLayout>
    </>
  );
};
